<template>
  <div v-if="isOpen" class="modal-overlay w-full h-full">
    <div class="popup popup--invite">
      <popup-header :title="$t('popup.invite.title')" @close="closePopup" />
      <div class="popup__content popup__content--invite">
        <img
          v-if="theme"
          src="@/assets/images/invite-dark.svg"
          alt="invite"
          class="h-[213px]"
        />
        <img
          v-else
          src="@/assets/images/invite.svg"
          alt="invite"
          class="h-[213px]"
        />
        <span
          class="text-md font-semibold text-secondary-base dark:text-primary-white"
        >
          {{ $t("popup.invite.link") }}
        </span>

        <div class="flex flex-row">
          <input
            type="text"
            class="h-8 flex-1 outline-none border border-secondary-300 dark:border-[#292D35] rounded-l px-1 text-xs font-normal text-secondary-base dark:text-greyscale-500 border-r-0 dark:bg-dark-mode-150"
            v-model="link"
          />
          <Button
            class="primary !h-8 text-[10px] rounded-r rounded-l-none !w-20 flex-none"
            @click="copyToClipboard"
          >
            {{ $t(copyText) }}
          </Button>
        </div>

        <div
          class="flex flex-row gap-2 items-center mt-3 cursor-pointer showDescription"
          @click="showDescription = !showDescription"
        >
          <span
            class="text-md font-semibold text-secondary-base dark:text-primary-white"
          >
            {{ $t("popup.invite.accordion_title") }}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            :class="{ arrow_side: !showDescription }"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
        <div v-if="showDescription">
          <p class="text-sm font-light dark:text-greyscale-500">
            {{ $t("popup.invite.accordion_desc") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PopupHeader from "@/components/PopupHeader";
import Button from "@/components/Button";
export default {
  name: "InvitePopup",
  components: { PopupHeader, Button },
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      copyText: "button.collaboration.copylink",
      showDescription: false,
    };
  },
  created() {
    this.theme = this.getTheme === "dark";
  },
  computed: {
    ...mapGetters(["qrLink", "getTheme"]),
  },
  watch: {
    qrLink() {
      this.link = this.qrLink;
    },
  },
  methods: {
    closePopup() {
      this.$emit("close");
    },
    copyToClipboard() {
      this.copyText = "button.general.copied";
      navigator.clipboard.writeText(this.link).then(() => {
        setTimeout(() => {
          this.copyText = "button.collaboration.copylink";
        }, 1000);
      });
    },
  },
};
</script>

<style scoped>
@import "index.module.css";
</style>
